import { Alert, Box } from "@mui/material";
import { WhitelabelApp } from "../../context/WhitelabelContext";

interface AppFrameProps {
  app: WhitelabelApp | null;
}

export default function AppFrame({ app }: AppFrameProps) {
  if (!app) {
    return (
      <Alert severity="warning">
        App not found. It may have been removed by your administrator.
      </Alert>
    );
  }

  if (!app.enabled) {
    return (
      <Alert severity="info">
        The "{app.name}" app is currently disabled.
      </Alert>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: { xs: "calc(100vh - 56px)", sm: "calc(100vh - 64px)" },
        display: "flex",
      }}
    >
      <iframe
        key={app.id}
        src={app.url}
        title={app.name}
        style={{
          flex: 1,
          width: "100%",
          height: "100%",
          border: "none",
          display: "block",
        }}
        sandbox="allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-downloads allow-presentation"
        referrerPolicy="no-referrer-when-downgrade"
        allow="clipboard-read; clipboard-write; camera; microphone; geolocation; fullscreen"
      />
    </Box>
  );
}
